import { Stack, Text } from "@chakra-ui/react";
import { withApiError } from "@raiden/library/components/ReactHookForm/ApiError";
import { useApi } from "@raiden/library/hooks/useApi";
import generateApiUri from "@raiden/library/libraries/utils/generateApiUri";
import { useIntl } from "react-intl";
import SWRHandler from "../../../components/SWR/SWRHandler";
import SignUpHandler from "./Handler";

/**
 * @typedef {object} Props
 *
 * @param {Props} props
 */
function SignUp(props) {
  const intl = useIntl();

  /** @type {import("@raiden/library/hooks/useApi").UseApi<import("@raiden/library/types/Countries/Country").Country[]>} */
  const { swrResponse: swrResponseCountries } = useApi(
    generateApiUri({ id: "@countries.viewAny", query: { per_page: 250 } }),
  );

  return (
    <Stack spacing="1rem">
      <Text
        color="gray.700"
        fontWeight="700"
        fontSize="1.5rem"
        textAlign="center">
        {intl.formatMessage({
          defaultMessage: "Inscrivez-vous",
        })}
      </Text>

      <SWRHandler swrResponse={swrResponseCountries}>
        {(response) => <SignUpHandler countries={response.data} />}
      </SWRHandler>
    </Stack>
  );
}

export default withApiError(SignUp);
